// anime.js - https://animejs.com/
import anime from 'animejs/lib/anime.es.js';

import {initialiseSection1} from './sections';

/**
 * Programmatically initialises all timelines based on an array of options.
 * While not entirely dynamic, it does allow for a more concentrated area of
 * options.
 */
const initialiseTimelines = () => {
  let timelines;
  // Options below are defined for the timeline and children; ergo as many options
  // should be placed in here where possible.
  // Parameters can be set through a function also, which should be taken
  // advantage of where possible.
  // Easing should remain 'easeInOutSine' throughout.
  let timelineOptions = [
    {
      autoplay: true,
      direction: 'alternate',
      loop: true,
    },
    {
      duration: 1000,
      easing: 'easeInOutSine',
      autoplay: false,
    },
    {
      duration: 1000,
      easing: 'easeInOutSine',
      autoplay: false,
    },
    {
      duration: 1000,
      easing: 'easeInOutSine',
      autoplay: false,
    },
    {
      duration: 1000,
      easing: 'easeInOutSine',
      autoplay: false,
    },
  ];

  // Map the timeline options to individual timelines.
  timelines = timelineOptions.map((options) => anime.timeline(options));

  // UI Elements
  initialiseSection1(timelines[0]);
};

exports.initialiseTimelines = initialiseTimelines;
